import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketCustomerInfo } from '../../../../state';
import { useGraphProfile } from '../../../../hooks';

const CustomerNameEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { graphData } = useGraphProfile();

  useEffect(() => {
    if (graphData?.displayName && !currentTicket?.customerInfo.customerName) {
      dispatch(updateTicketCustomerInfo({ customerName: graphData.displayName }));
    }
  }, [dispatch, graphData, currentTicket?.customerInfo.customerName]);

  return (
    <TextField
      label="Customer Name"
      size="small"
      fullWidth
      value={currentTicket?.customerInfo.customerName || ''}
      placeholder="Auto-populated from user profile"
      disabled={true}
    />
  );
};

export default CustomerNameEdit;
